import { colors } from '@sweep-io/sweep-design';
import { DASHBOARD_HEADER_HEIGHT_PX, PAGE_SIDE_PADDING } from '../../../constants';

export const commonWrapperStyles = {
  boxShadow: 1,
  position: 'absolute' as const,
  top: '16px',
  background: colors.white,
  width: '464px',
  height: 'calc(100% - 32px)',
  borderRadius: '8px',
  overflow: 'hidden',
  zIndex: 2,
};

export const staticViewSx = {
  position: 'relative',
  height: `calc(100vh - ${DASHBOARD_HEADER_HEIGHT_PX})`,
  right: 0,
  left: 'auto',
  top: `-${PAGE_SIDE_PADDING}px`,
  width: '464px',
  overflow: 'auto',
  boxShadow: 'none',
  borderRadius: '0px',
  borderLeft: `1px solid ${colors.grey[120]}`,
};
